import {types} from 'mobx-state-tree';

const AirbnbListingModel = types.model('AirbnbListingModel', {
  id: types.identifierNumber,
  name: types.string,
  address: types.string,
  lat: types.number,
  lng: types.number,
  countryCode: types.optional(types.string, ''),
  thumbnailUrl: types.optional(types.string, ''),
  pictureUrl: types.optional(types.string, ''),
  bedrooms: types.optional(types.number, 1),
  photos: types.array(
    types.model({
      id: types.identifierNumber,
      picture: types.string,
      caption: types.string
    })
  )
});

export type AirbnbListingModelType = typeof AirbnbListingModel.Type;
export default AirbnbListingModel;



// WEBPACK FOOTER //
// ./src/models/AirbnbListingModel/AirbnbListingModel.ts